<script lang="ts" setup>
import { useRouter, useRoute } from 'vue-router'
import { usePayrollStore } from '@/store/payroll-data'
import { DynamicForm } from '../../dynamic-form'
import { getForm } from '../../../core/services/forms'
import { onBeforeMount, ref } from 'vue'
import { useNotificationsStore } from '@/store/notifications'
import { usePayrollChange } from '@/app/core/composable/routes/useChangePayroll'
import { notificationError } from '@/app/core/util/notificationUtils'
import { DLoading } from 'front-library'
import { useI18n } from 'vue-i18n'
import {
  getEmployee,
  getEmployeeCodeType,
  createEmployee,
  updateEmployee
} from '../../../core/services/employees'
usePayrollChange(() =>
  Boolean(route.params.id) ? back() : window.location.reload()
)

/* store, router, notifications */
const storePayroll = usePayrollStore()
const notifications = useNotificationsStore()
const router = useRouter()
const route = useRoute()
const { t } = useI18n()

/* Datos componente Loading */
const loading = ref(false)
const messageLoading = ref('')

/* Datos */
const customForm = ref<any>({})
let model: any = {}

const onSubmit = async (model: any) => {
  loading.value = true
  let saved = false
  try {
    if (!route.params.id) {
      saved = await createEmployee(model)
    } else {
      saved = await updateEmployee(model, `${route.params.id as string}`)
    }
    if (saved) {
      loading.value = false
      notifications.addNotification({
        title: !route.params.id
          ? t('notification.created')
          : t('notification.edited'),
        text: t('employees.notification.action', [
          !route.params.id
            ? t('notification.wasCreated')
            : t('notification.wasEdited')
        ]),
        type: 'success',
        time: 10000
      })
      void router.push({ name: 'ListEmployees' })
    }
  } catch (error: any) {
    notificationError(error, 'employees', t, notifications, loading)
  }
}

const getEntity = async () => {
  if (!route.params.id) return
  model = await getEmployee(route.params.id as string)
  if (model === undefined) {
    notifications.addNotification({
      title: t('notification.notFound'),
      text: t('employees.notification.error'),
      type: 'error',
      time: 10000
    })
    back()
  }
}

/* Volver */
const back = () => {
  void router.push({ name: 'ListEmployees' })
}

onBeforeMount(async () => {
  loading.value = true
  try {
    await getEntity()
    customForm.value = await getForm({ entity: 'employees' })
    if (route.params.id !== undefined) messageLoading.value = t('loading.data')
    const EmployeeCodeType = await getEmployeeCodeType(
      storePayroll.payroll?.id ?? ''
    )
    const modifications: any = {
      //Alfanumérico
      2: {
        rules: ['required'],
        props: {
          required: true
        }
      },
      //Consecutivo
      1: {
        props: {
          disabled: true,
          placeholder: 'Código consecutivo'
        }
      }
    }
    for (const tab of Object.values(customForm.value.tabs)) {
      for (const group of (tab as any).groups) {
        for (const field of group.fields) {
          if (field.name === 'code') {
            const modification = modifications[EmployeeCodeType]
            if (modification) {
              if (modification.rules) field.rules.push(...modification.rules)
              if (modification.props && field.props)
                Object.assign(field.props, modification.props)
              else if (modification.props) field.props = modification.props
            }
          }
        }
      }
    }
    loading.value = false
  } catch (error: any) {
    if (error.response.status === 400) {
      notifications.addNotification({
        title: t('notification.notFound'),
        text: t('employees.notification.error'),
        type: 'error',
        time: 10000
      })
      back()
    } else {
      notificationError(error, 'employees', t, notifications, loading)
    }
  }
})
</script>
<template>
  <DLoading v-show="loading" :message="messageLoading" />
  <div class="h-full px-5">
    <div class="bg-gray-50 pb-4">
      <div class="leading-4 pt-responsive">
        <p
          class="text-3xl font-semibold text-shadow text-blue-900"
          v-html="
            route.params.id == undefined
              ? t('employees.create')
              : t('employees.edit')
          " />
      </div>
    </div>
    <DynamicForm
      v-if="customForm?.tabs"
      :form-schema="customForm"
      :initial-model="model"
      :title-btn-save="
        route.params.id === undefined
          ? t('form.button.save')
          : t('form.button.update')
      "
      @cancel="back"
      @submit="onSubmit" />
  </div>
</template>
